import { InputSignal, InputSignalWithTransform } from '@angular/core';

type UnwrapInput<T> =
  T extends InputSignal<infer V>
    ? V
    : T extends InputSignalWithTransform<infer V, unknown>
      ? V
      : T;

export type ComponentInputs<T> = {
  [K in keyof T]?: UnwrapInput<T[K]>;
};

export const MODAL_CLOSE_EVENT = 'close';
